window.inputmask = require('inputmask/dist/jquery.inputmask.js');
window.autoComplete = require('bootstrap-autocomplete');
window.datepicker = require('bootstrap-datepicker');

/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    let ac = $('.auto-complete');
    let acName = ac.attr('name');

    if (ac.length) {
        ac
          .prop('autocomplete', 'off')
          .attr('name', acName + '-autocomplete')
          .attr('id', acName + '-autocomplete')
          .autoComplete();

        if ($( '#' + acName ).length === 0) {
            $('<input type="hidden" id="' + acName + '" name="' + acName + '">')
              .insertAfter( ac );
        }

        ac.on('autocomplete.select', function (evt, value) {
            $( '#' + acName ).val( value.value );
        })
    }



    $('.mask-phone').inputmask({"mask": "(999) 999-9999"});

    $('.date-picker')
      .prop('autocomplete', 'off')
      .datepicker({
          orientation: 'bottom'
      });

    /**
     * Checkbox tree for permission selecting
     */
    $('#tree :checkbox').on('click change', function (){
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    $('#tree :checkbox').each(function () {
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function(e) {
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to delete this item?',
            showCancelButton: true,
            confirmButtonText: 'Confirm Delete',
            cancelButtonText: 'Cancel',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    })
        .on('submit', 'form[name=confirm-item]', function (e) {
            e.preventDefault();

            Swal.fire({
                title: 'Are you sure you want to do this?',
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('click', 'a[name=confirm-item]', function (e) {
        /**
         * Add an 'are you sure' pop-up to any button/link
         */
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to do this?',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            icon: 'info',
        }).then((result) => {
            result.value && window.location.assign($(this).attr('href'));
        });
    });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="'+hash+'"]').tab('show');
    }

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();

    function youtube_parser(url){
        let regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
        let match = url.match(regExp);
        return (match && match[1].length===11) ? match[1] : false;
    }

    $( 'oembed' ).each( function( index, el ) {
        let media = $( el );
        let mediaUrl = media.attr( "url" );

        if (mediaUrl.includes('youtube.com')) {
            let ytId = youtube_parser(mediaUrl);
            $('<iframe class="youtube-embed" width="560" height="315" src="https://www.youtube.com/embed/'+ytId+'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>').insertBefore(media);
        }

        media.remove();
    });

    $('#answers').find('input[type="radio"]').change(function () {
        $('.is-valid').removeClass('is-valid');
        $(this).addClass('is-valid');
        $('input.' + $(this).attr('id')).addClass('is-valid');
    });

    // hack to show filename on fancy uploads
    $('.custom-file-input').on('change', function(){
        $(this).next('.custom-file-label')
          .html($(this).val().split('\\').pop());
    });

    $('.edit-agency-relationship').click(function (e) {
        let modal = $('#editAgency');
        let row = $(this).parentsUntil('tr').parent();
        let effectiveDate = row.find('.effective_date').text();
        let expirationDate = row.find('.expiration_date').text();
        let reason = row.find('.reason').text();
        let checkedPermissions = $(this).attr('data-permissions').split(',');

        if (!effectiveDate.includes('/')) {
            effectiveDate = '';
        }

        if (!expirationDate.includes('/')) {
            expirationDate = '';
        }

        modal.find('.relationship_id').val($(this).attr('data-id'));
        modal.find('#effective_date').val(effectiveDate);
        modal.find('#expiration_date').val(expirationDate);

        modal.find('#reason option').prop('selected', false);
        modal.find('#reason option[value="' + reason + '"]').prop('selected', true);

        modal.find('input[name="permissions[]"]').each(function(){
            let val = $(this).val();

            if(checkedPermissions.indexOf(val) > -1) {
                $(this).prop('checked', true);
            }
        });
    });

    $('table').each(function() {
        if ($(this).find('th:last-child').text().replace(/\s/g, "") === 'Actions') {
            $(this).find('th:last-child').text('');
            $(this).find('tr > td:last-child').addClass('text-right');
        }
    });

    $(window).scroll(function() {
        if ($(window).scrollTop() >= 30) {
            $('header.c-header').addClass("with-shadow");
        } else {
            $('header.c-header').removeClass("with-shadow");
        }
    });

    window.addEventListener('reportSelected', event => {
        $('#commission-reports-menu')
          .dropdown('dispose')
          .dropdown();
    });
});
